import React from 'react';

import { useIntl } from 'react-intl';
import { Image, StyleSheet } from 'react-native';

import { routes } from 'utils/routing';

import {
  EmptyScreenWrapper,
  HeaderText,
  ImageWrapper,
  StyledActionButtonLink,
  SubText,
} from './styled';

const friesImage = require('./fries.png');

const OffersEmptyScreen: React.FC = () => {
  const { formatMessage } = useIntl();
  // Texts and link path change depending on store is select or not
  const headerText = 'offersNoOffersAvailable';
  const subHeaderText = 'offersYouCanStillEnjoyYourFavorites';
  const linkText = 'orderNow';
  const linkPath = routes.menu;

  return (
    <EmptyScreenWrapper>
      <ImageWrapper>
        <Image style={styles.image} source={friesImage} />
      </ImageWrapper>
      <HeaderText>{formatMessage({ id: headerText })}</HeaderText>
      <SubText>{formatMessage({ id: subHeaderText })}</SubText>
      <StyledActionButtonLink to={linkPath}>
        {formatMessage({ id: linkText })}
      </StyledActionButtonLink>
    </EmptyScreenWrapper>
  );
};

const styles = StyleSheet.create({
  image: {
    width: 300,
    height: 300,
  },
});

export default OffersEmptyScreen;
